import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import BigIcon from 'UI/atoms/BigIcon';
import CardContent from 'UI/atoms/CardContent';
import Subtitle from 'UI/atoms/Subtitle';
import TextBox from 'UI/atoms/TextBox';
import Title from 'UI/atoms/Title';
import Link from 'UI/atoms/Link';

import warning from 'assets/img/icon/warning.png';

import styles from './styles.module.scss';

const CompanyRejected = () => {
  const { t } = useTranslation();

  return (
    <>
      <CardContent sm={{ span: 10, offset: 1 }}>
        <BigIcon src={warning} />
        <Title>{t('company.rejected.title')}</Title>
        <Row>
          <Col xs={12} sm={{ span: 10, offset: 1 }}>
            <Subtitle>
              {t('company.rejected.subtitle')}
            </Subtitle>
          </Col>
        </Row>

        <div className={styles.box}>
          <TextBox color="blue">
            <p>{t('register_validation.download_text')}</p>
            <Link arrow="down" href={t('register_validation.download_href')}>
              <strong>{t('register_validation.download_link')}</strong>
            </Link>
          </TextBox>
        </div>
      </CardContent>

      <CardContent color="gray" type="no-padding" sm={{ span: 12 }}>
        <TextBox>
          <p>{t('register_validation.footer_text')}</p>
          <Link href={t('web.domain')} target="_blank" arrow="right">
            {t('register_validation.footer_link_text')}
          </Link>
        </TextBox>
      </CardContent>
    </>
  );
};

export default CompanyRejected;
